import * as React from "react";
import styled from "styled-components";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";

interface FullWidthImageOnRightBlockProps {
  /** PIERWSZY KAWAŁEK TYTUŁU => CZARNY */
  blockTitlePart1Black: string

  /** DRUGI KAWAŁEK TYTUŁU => NIEBIESKI */
  blockTitlePart2Blue: string

  /** TRZECI KAWAŁEK TUTUŁU => CZARNY */
  blockTitlePart3Black: string

  /** PODTYTUŁ => SZARY */
  blockSubtitle: string | string[]

  /** TESTY W BLOKU */
  blockParagraphs: string[]

  /** TEXT PRZYCISKU */
  blockButtonText: string

  /** LINK DO LINKA */
  blockButtonLink: string

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TYPE TO TRIGER ON BUTTON CLICK */
  buttonClickEventType?: GoogleAnalyticsEventType
}

interface FullWidthImageOnRightBlockState {}

class FullWidthImageOnRightBlock extends React.Component<FullWidthImageOnRightBlockProps,FullWidthImageOnRightBlockState> {

  constructor(props: FullWidthImageOnRightBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onButtonClick() {
    if (this.props.buttonClickEventType) {
      googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
    }
  }

  render() {
    const {blockTitlePart1Black,blockTitlePart2Blue,blockTitlePart3Black,blockSubtitle,blockParagraphs,blockButtonText,blockButtonLink} = this.props;

    // SPRAWDZANIE CZY SUBTITLE JEST LISTĄ
    const blockSubtitleIsArray: boolean = Array.isArray(blockSubtitle);

    // ZWRACANIE DANYCH
    return (
      <div className="goodgrowth-theme-styles" onMouseEnter={this.onComponentView}>
        <FullWidthImageOnRightBlockWrapper className="aboutus">
          <div className="row">
            <div className="col-sm-8 col-md-6 wow fadeInLeft">
              <hr className="small" />
              <h2>{blockTitlePart1Black}<span>{blockTitlePart2Blue}</span>{blockTitlePart3Black}</h2>
              {!blockSubtitleIsArray && <StyledH4>{blockSubtitle}</StyledH4>}
              {blockSubtitleIsArray && (blockSubtitle as string[]).map((blockSubtitlePart: string, i: number) => <StyledH4 key={i}>{blockSubtitlePart}</StyledH4>)}
              {blockParagraphs.map((paragraph: string, index: number) => <p key={index}>{paragraph}</p>)}
              <a className="btn btn-default" href={blockButtonLink} target="_blank" onClick={this.onButtonClick}>{blockButtonText}</a>
            </div>
            <div className="col-sm-4 col-md-6">
            </div>
          </div>
        </FullWidthImageOnRightBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const FullWidthImageOnRightBlockWrapper = styled.section`
  a {
    margin-bottom: 0 !important;
    line-height: 22px !important;
  }
`;

const StyledH4 = styled.h4`
  color: rgb(128, 128, 128) !important;
  font-size: 20px !important;
  margin-top: -25px !important;
  margin-bottom: 20px !important;
  font-weight: 300 !important;
`;

export default FullWidthImageOnRightBlock


// WEBPACK FOOTER //
// ./src/layouts/full-width-image-on-right-block/full-width-image-on-right-block.tsx